/**
 * Converts a kebab-case (slug) string into a Title Case string.
 *
 * @param {string} slug - The input slug to convert, e.g. "my-awesome-slug"
 * @returns {string} The converted title case string with first letters capitalized
 * @throws {TypeError} If input is not a string
 * @example
 * convertSlugToTitle('hello-world'); // Returns "Hello World"
 * convertSlugToTitle('product-page'); // Returns "Product Page"
 */
export function convertSlugToTitle(slug: string): string {
  return slug
    .split('-')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1))
    .join(' ')
}
